module.exports = __webpack_public_path__ + "img/tottenham-hotspur.2638f71a.png";